import React, { useState, useEffect } from "react"
import SidePanelLayout from "aldoo-ra/SidePanel"
import Posts from "./Posts"
import Categories from "./Categories"

const AdminBlogHome = () => {
  return (
    <SidePanelLayout
      menuName="AdminBlogMenu"
      tabs={{
        posts: Posts,
        categories: Categories,
      }}
    />
  )
}

export default AdminBlogHome
